import { DestroyRef, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivate, CanDeactivate } from '@angular/router';
import { ErrorService } from '@shared/services/error.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { firstValueFrom } from 'rxjs';
import { PopupSelectHospitalComponent } from 'src/app/shared/components/popup-select-hospital/popup-select-hospital.component';
import { UserService } from 'src/app/shared/services/user.service';
import { InstanceIdService } from '@shared/services/instance-id.service';

@Injectable({
  providedIn: 'root',
})
export class MultipleHospitalsGuard implements CanActivate, CanDeactivate<any> {
  private instanceId: string;

  constructor(
    private userService: UserService,
    private dialog: MatDialog,
    private errorService: ErrorService,
    private subscriptionManager: SubscriptionManager,
    private destroyRef: DestroyRef,
    private instanceIdService: InstanceIdService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
  }

  async canActivate(): Promise<boolean> {
    if (this.userService.isCurrentUserHasMultipleHospitals()) {
      const hospitals = this.userService.getSelectedHospitals();
      if (hospitals.length !== 1) {
        try {
          const dialogRef = this.dialog.open(PopupSelectHospitalComponent, {
            width: '384px',
            height: '280px',
            data: {
              hospitalsSelected: hospitals.length > 0,
              compatible: true,
            },
          });

          const res: any = await firstValueFrom(
            this.subscriptionManager.createRequest(dialogRef.afterClosed(), this.instanceId, this.instanceId)
          );

          if (res?.success === true) {
            this.userService.changedHospitalsSelectedSubject.next();
            this.userService.soloHospitalModeSubject.next(true);
            return true;
          } else if (res?.isClosePopup) {
            return false;
          }

          this.userService.soloHospitalModeSubject.next(false);
          return false;
        } catch (error) {
          this.errorService.handleError(error);
          return false;
        }
      } else {
        this.userService.soloHospitalModeSubject.next(true);
        return true;
      }
    } else {
      return true;
    }
  }

  canDeactivate(): boolean {
    this.userService.soloHospitalModeSubject.next(false);
    return true;
  }
}
